"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var AutoComplete = react_1.forwardRef(function (props, ref) {
    var inputRef = react_1.useRef();
    var _a = react_1.useState(''), autoInput = _a[0], setAutoInput = _a[1];
    var _b = react_1.useState(new Array()), searchResult = _b[0], setSearchResult = _b[1];
    var _c = react_1.useState(false), dropdownOpen = _c[0], setDropdownOpen = _c[1];
    var toggle = function () { return setDropdownOpen(function (prevState) { return !prevState; }); };
    var onSearch = function (e) {
        var result = new Array();
        var inputValue = e.target.value;
        if (inputValue.length > 3) {
            result = props.onSearch();
            console.log(result);
        }
        if (result != null && result.length > 0)
            setSearchResult(__spreadArrays(result));
    };
    var selectItem = function (e, item) {
        setAutoInput(item.value);
        console.log('clicked selectItem: ' + item);
        setNativeInput("autoInput", item.label);
        toggle();
    };
    react_1.useImperativeHandle(ref, function () { return ({
        setSearchResult: function (parentResult) {
            console.log('parentResult');
            console.log(parentResult);
            setSearchResult(__spreadArrays(parentResult));
            toggle();
        },
        getSearchList: function () {
            console.log('searchResult');
            console.log(searchResult);
            return searchResult;
        },
        getValue: function () {
            console.log('autoInput');
            console.log(autoInput);
            return autoInput;
        },
        callToggle: function () {
            toggle();
        }
    }); });
    var setNativeInput = function (idName, value) {
        var input = document.querySelector('#' + idName);
        // This will work by calling the native setter bypassing Reacts incorrect value change check
        var obj = Object;
        obj.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')
            .set.call(input, value);
        // This will trigger a new render wor the component
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    react_1.useEffect(function () {
    }, [inputRef, autoInput, setAutoInput, searchResult, setSearchResult, dropdownOpen, setDropdownOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(reactstrap_1.InputGroup, null,
            React.createElement(reactstrap_1.Input, { type: "text", id: "autoInput", autocomplete: "off", ref: inputRef, style: props.style, placeholder: props.placeholder, className: props.className, onChange: function (e) { return onSearch(e); } }),
            dropdownOpen === true ?
                React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                    React.createElement(reactstrap_1.Button, { type: "button", onClick: toggle, color: "secondary" }, "Close")) : React.createElement(React.Fragment, null)),
        React.createElement(reactstrap_1.Dropdown, { isOpen: dropdownOpen, toggle: toggle },
            React.createElement(reactstrap_1.DropdownToggle, { tag: "span", "data-toggle": "dropdown", "aria-expanded": dropdownOpen }),
            React.createElement(reactstrap_1.DropdownMenu, null,
                React.createElement(reactstrap_1.DropdownItem, { header: true }, "Search result:"),
                searchResult.map(function (item) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(reactstrap_1.DropdownItem, { divider: true }),
                        React.createElement(reactstrap_1.DropdownItem, { onClick: function (e) { return selectItem(e, item); } }, item.label));
                })))));
});
exports.default = AutoComplete;
//# sourceMappingURL=AutoComplete.js.map